import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import fetchApi from "api/fetchApi";
import { IUser } from "models/Employee";

const AllDepartments = () => {
  const [departments, setDepartments] = useState<{ [key: string]: IUser[] }>({});
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchApi(`users`).get("");
        if (response.success) {
          const employees = response.data.data as IUser[];

          const groupedDepartments: { [key: string]: IUser[] } = {};
          employees.forEach((employee) => {
            const department = employee.department.title;
            if (!groupedDepartments[department]) {
              groupedDepartments[department] = [];
            }
            groupedDepartments[department].push(employee);
          });

          setDepartments(groupedDepartments);
        } else {
          console.log("Error while retrieving users");
        }
      } catch (error) {
        console.log("Error while fetching users", error);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <Box>
      {loading ? (
        <div className="loader">
          <div className="justify-content-center jimu-primary-loading"></div>
        </div>
      ) : (
        <>
          {Object.keys(departments).map((department, index) => (
            <Card key={index} elevation={3} style={{ marginBottom: '20px' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="#146ED2" fontWeight={800}>
                  {department} Department
                </Typography>
                <Typography variant="body2">
                  Number of Employees: {departments[department].length}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </>
      )}
    </Box>
  );
};

export default AllDepartments;
